export const financing = {
  // Header
  title: 'Solutions de Financement',
  subtitle: 'Options de financement flexibles pour faire avancer votre entreprise. Nous travaillons avec plusieurs prêteurs pour trouver les meilleurs taux et conditions pour votre situation.',
  
  // Navigation Tabs
  overview: 'Aperçu',
  options: 'Options de Financement',
  calculator: 'Calculateur de Paiement',
  requirements: 'Exigences',
  
  // Overview Tab
  whyChooseFinancing: 'Pourquoi Choisir Notre Financement?',
  whyChooseFinancingDesc: 'Nous facilitons l\'obtention du véhicule commercial dont vous avez besoin',
  quickApproval: 'Approbation Rapide',
  quickApprovalDesc: 'Obtenez une pré-approbation en minutes avec notre processus de demande simplifié',
  competitiveRates: 'Taux Compétitifs',
  competitiveRatesDesc: 'L\'accès à plusieurs prêteurs vous assure d\'obtenir les meilleurs taux disponibles',
  flexibleTerms: 'Conditions Flexibles',
  flexibleTermsDesc: 'Personnalisez votre calendrier de paiement pour correspondre au flux de trésorerie de votre entreprise',
  readyToStart: 'Prêt à Commencer?',
  readyToStartDesc: 'Nos spécialistes en financement sont là pour vous aider à trouver la solution parfaite pour vos besoins d\'entreprise.',
  applyNow: 'Postuler Maintenant',
  speakWithSpecialist: 'Parler avec un Spécialiste',
  
  // Financing Options
  financingOptionsTitle: 'Options de Financement',
  financingOptionsDesc: 'Choisissez la solution de financement qui fonctionne le mieux pour votre entreprise',
  traditionalFinancing: 'Financement Traditionnel',
  traditionalFinancingDesc: 'Prêt auto standard avec taux compétitifs pour acheteurs qualifiés',
  commercialLease: 'Bail Commercial',
  commercialLeaseDesc: 'Options de bail avec paiements mensuels plus bas et avantages fiscaux',
  interestRate: 'Taux d\'Intérêt:',
  termLength: 'Durée du Terme:',
  downPayment: 'Mise de Fonds:',
  learnMore: 'En Savoir Plus',
  
  // Features
  fixedRates: 'Taux d\'intérêt fixes',
  quickApprovalFeature: 'Approbation rapide',
  noPrepayment: 'Aucune pénalité de remboursement anticipé',
  lowerPayments: 'Paiements mensuels plus bas',
  taxDeductible: 'Déductible d\'impôt',
  upgradeFlexibility: 'Flexibilité de mise à niveau',
  maintenancePackages: 'Forfaits d\'entretien disponibles',
  
  // Payment Calculator
  calculatorTitle: 'Calculateur de Paiement',
  calculatorDesc: 'Estimez vos paiements mensuels (taxes du Québec incluses)',
  loanDetails: 'Détails du Prêt',
  vehiclePrice: 'Prix du Véhicule (Avant Taxes)',
  downPaymentLabel: 'Mise de Fonds',
  interestRateLabel: 'Taux d\'Intérêt (%)',
  loanTermLabel: 'Terme du Prêt (mois)',
  calculatePayment: 'Calculer le Paiement',
  paymentBreakdown: 'Répartition du Paiement',
  monthlyPayment: 'Paiement Mensuel',
  taxBreakdown: 'Répartition des Taxes (Québec)',
  gst: 'TPS (5%):',
  qst: 'TVQ (9.975%):',
  totalTaxes: 'Total des Taxes:',
  vehiclePriceTaxes: 'Prix du Véhicule + Taxes',
  loanAmount: 'Montant du Prêt',
  totalInterest: 'Intérêt Total',
  totalAmount: 'Montant Total',
  estimateDisclaimer: 'Ceci est une estimation incluant les taxes du Québec (TPS + TVQ). Les taux et conditions réels peuvent varier selon l\'approbation de crédit.',
  
  // Requirements
  requirementsTitle: 'Exigences de Financement',
  requirementsDesc: 'Ce dont vous aurez besoin pour faire une demande de financement',
  requiredDocuments: 'Documents Requis',
  quickPreApproval: 'Pré-Approbation Rapide',
  quickPreApprovalDesc: 'Obtenez une pré-approbation en aussi peu que 15 minutes avec notre processus de demande simplifié.',
  startApplication: 'Commencer la Demande',
  
  // Requirements List
  validLicense: 'Permis de conduire valide',
  proofIncome: 'Preuve de revenu (2 derniers talons de paie ou déclarations de revenus)',
  bankStatements: 'Relevés bancaires (3 derniers mois)',
  businessLicense: 'Licence d\'entreprise (pour achats commerciaux)',
  proofWork: 'Preuve de travail contractuel',
  insuranceInfo: 'Informations d\'assurance',
  references: 'Références (personnelles et d\'entreprise)'
};